import type { TableStyles } from "react-data-table-component";

const CUSTOM_STYLES : TableStyles = {
    table: {
        style: {
            width: '100%',
            tableLayout: 'fixed' as const,
        },
    },
    header: {
        style: {
            backgroundColor: 'transparent',
            border: 'none',
            padding: 0,
        },
    },
    headRow: {
        style: {
            backgroundColor: '#f8fafc',
            borderBottom: '1px solid #e2e8f0',
            minHeight: '52px',
            fontSize: '14px',
            fontWeight: '600',
            width: '100%',
        },
    },
    headCells: {
        style: {
            fontSize: '14px',
            fontWeight: '600',
            color: '#374151',
            paddingLeft: '16px',
            paddingRight: '16px',
            fontFamily: 'Montserrat, sans-serif',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap' as const,
        },
    },
    rows: {
        style: {
            backgroundColor: 'white',
            borderBottom: '1px solid #f1f5f9',
            minHeight: '64px',
            fontSize: '14px',
            width: '100%',
            '&:hover': {
                backgroundColor: '#f8fafc',
            },
        },
    },
    cells: {
        style: {
            paddingLeft: '0px',
            paddingRight: '4px',
            fontFamily: 'Montserrat, sans-serif',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap' as const,
        },
    },
    pagination: {
        style: {
            backgroundColor: 'white',
            borderTop: '1px solid #e2e8f0',
            // padding: '16px',
            fontFamily: 'Montserrat, sans-serif',
        },
    },
}

export {
    CUSTOM_STYLES
}